export enum TimeTrackingBillingTimeEnum {
  FIRST_DAY = 'FIRST_DAY',
  LAST_DAY = 'LAST_DAY',
}
